module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": "Enviar Orçamento por Email",
      "modal": _vm.showFormEmail,
      "loadingSave": _vm.loadingTable,
      "onSave": _vm.proposta,
      "width": "95%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)]), _vm._v(" "), _c('b-table-simple', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTable),
      expression: "loadingTable"
    }],
    staticClass: "table-v2 mt-1",
    attrs: {
      "id": "table-v0",
      "small": "",
      "outlined": "",
      "borered": ""
    }
  }, [_c('b-thead', [_c('b-tr', [_c('b-th', [_vm._v("DESCRIÇÃO")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("QUANTIDADE")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("VALOR (R$)")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("ATUALIZAÇÃO")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "150"
    }
  })], 1)], 1), _vm._v(" "), _c('b-tbody', [_c('b-tr', [_c('b-td', {
    staticStyle: {
      "background": "#f9f6db",
      "font-weight": "bold",
      "height": "40px"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-usd",
      "type": "text"
    }
  }), _vm._v("\n          CUSTO DAS MEDIÇÕES\n        ")], 1)], 1), _vm._v(" "), _vm._l((_vm.formData.servicosMedicao), function(data, i) {
    return _c('b-tr', {
      key: i + 1000
    }, [_c('b-td', {
      style: ('font-size:7.5pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_vm._v("\n          " + _vm._s(data.nome) + "\n        ")]), _vm._v(" "), _c('b-td', {
      style: ('font-size:7.5pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_vm._v("\n          " + _vm._s(data.total) + "\n        ")]), _vm._v(" "), _c('b-td', {
      style: ('font-size:7.5pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_vm._v("\n          " + _vm._s(data.valor_venda) + "\n          "), (
      _vm.response.options &&
      _vm.response.options.data &&
      _vm.response.options.data[data.id]
    ) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_c('br'), _vm._v(_vm._s(_vm.response.options.data[data.id][0]) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('b-td', {
      style: ('font-size:7.5pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_vm._v("\n          ---\n        ")]), _vm._v(" "), _c('b-td', {
      style: ('font-size:7.5pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_vm._v("\n          ---\n        ")])], 1)
  }), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold",
      "height": "40px"
    }
  }, [_vm._v("\n          TOTAL MEDIÇÕES\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formData.qtde_medicao) + "\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formData.valor_medicao) + "\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  })], 1), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "background": "#f9f6db",
      "font-weight": "bold",
      "height": "40px"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-usd",
      "type": "text"
    }
  }), _vm._v("\n          CUSTOS DOS SERVIÇOS\n        ")], 1), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#f9f6db",
      "font-weight": "bold"
    }
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "text",
      "title": "Inserir Novo Serviço",
      "value": "Inserir Novo Serviço"
    },
    on: {
      "click": function($event) {
        return _vm.onRegister()
      }
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.formData.servicos), function(data, i) {
    return _c('b-tr', {
      key: i
    }, [_c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text"
      },
      model: {
        value: (data.descricao),
        callback: function($$v) {
          _vm.$set(data, "descricao", $$v)
        },
        expression: "data.descricao"
      }
    })], 1), _vm._v(" "), _c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number"
      },
      on: {
        "change": _vm.formataCustoServicos
      },
      model: {
        value: (data.qtde),
        callback: function($$v) {
          _vm.$set(data, "qtde", $$v)
        },
        expression: "data.qtde"
      }
    })], 1), _vm._v(" "), _c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: ('money'),
        expression: "'money'"
      }],
      attrs: {
        "type": "text"
      },
      on: {
        "change": _vm.formataCustoServicos
      },
      model: {
        value: (data.valor),
        callback: function($$v) {
          _vm.$set(data, "valor", $$v)
        },
        expression: "data.valor"
      }
    })], 1), _vm._v(" "), _c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [(data.usuario) ? _c('div', [_vm._v("\n            " + _vm._s(data.usuario.usuario)), _c('br'), _vm._v("\n            " + _vm._s(_vm.toDate(data.updated_at)) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [(data.padrao == 0) ? _c('ed-button', {
      attrs: {
        "icon": "fa fa-trash",
        "type": "danger",
        "size": "mini",
        "title": "Deletar Registro"
      },
      on: {
        "click": function($event) {
          return _vm.onDelete(i)
        }
      }
    }) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold",
      "height": "40px"
    }
  }, [_vm._v("\n          TOTAL SERVIÇOS\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formData.qtde_servico) + "\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formData.valor_servico) + "\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  })], 1)], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-right d-flex flex-row-reverse bd-highlight",
    staticStyle: {
      "padding": "0 !important"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 text-center col-sm-12 col-md-6 col-lg-5 col-xl-4",
    staticStyle: {
      "padding": "0 !important"
    }
  }, [_c('b-table-simple', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTable),
      expression: "loadingTable"
    }],
    staticClass: "table-v2 mt-1",
    attrs: {
      "id": "table-v0",
      "small": "",
      "outlined": "",
      "borered": ""
    }
  }, [_c('b-thead', [_c('b-tr', [_c('b-th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("CUSTO TOTAL")])], 1)], 1), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "color": "#dd5a5a",
      "font-weight": "bold",
      "text-align": "left"
    }
  }, [_vm._v("\n            DESCONTOS\n          ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "color": "#dd5a5a",
      "font-weight": "bold",
      "text-align": "left"
    }
  }, [_c('el-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "change": _vm.formataCustoTotal
    },
    model: {
      value: (_vm.formData.valor_desconto),
      callback: function($$v) {
        _vm.$set(_vm.formData, "valor_desconto", $$v)
      },
      expression: "formData.valor_desconto"
    }
  })], 1)], 1), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "right",
      "font-size": "18px !important"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n            Custo Total\n            "), _c('span', {
    staticStyle: {
      "color": "#699e62"
    }
  }, [_vm._v("R$ " + _vm._s(_vm.formData.valor_total))])])], 1), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "right",
      "font-size": "18px !important"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n            Lucro Líquido\n            "), _c('span', {
    staticStyle: {
      "color": "#699e62"
    }
  }, [_vm._v("R$ " + _vm._s(_vm.formData.valor_lucro))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#699e62",
      "font-size": "15px !important"
    }
  }, [_vm._v("(" + _vm._s(_vm.formData.percent_lucro) + "%)")])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-floppy-o",
      "type": "primary",
      "value": "Salvar Orçamento"
    },
    on: {
      "click": _vm.salvar
    }
  }), _vm._v(" "), _c('ed-button', {
    attrs: {
      "icon": "fa fa-search-plus",
      "type": "warning",
      "value": "Prévia do Orçamento"
    },
    on: {
      "click": _vm.previa
    }
  }), _vm._v(" "), _c('ed-button', {
    attrs: {
      "icon": "fa fa-paper-plane",
      "type": "success",
      "value": "Enviar Orçamento"
    },
    on: {
      "click": function($event) {
        _vm.showFormEmail = !_vm.showFormEmail
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5afcbe60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/orcamento/servico.vue
// module id = 1513
// module chunks = 45